exports.UK_POST_CODE_FULL =
  /^(GIR[ ]?0AA)|([a-zA-Z]{1,2}(([0-9]{1,2})|([0-9][a-zA-Z]))[ ]?[0-9][a-zA-Z]{2})$/;
exports.CALLING_CARD_NUMBER = /^\d{8}$/; // 8 digits
exports.CHAR_8 = /^.{8}$/; // 8 char
exports.CHAR_9 = /^.{9}$/; // 9 char
exports.DIGIT_10 = /^\d{10}$/; // 10 digits
exports.DIGIT_11 = /^\d{11}$/; // 11 digits
exports.CHARACTERS_10_TO_28 = /^.{10,28}$/; // 10-28 characters (used for parcel number OR carrier ref)
exports.CHAR_BEGINNING_WITH_C_11_OR_12 = /^C.{10,11}$/i; // 11 or 12 chars beginning with C
exports.FIRST_TWO_CHARACTERS = /^[a-zA-Z]{2}[\s\S]*$/;
exports.UK_PHONE_NUMBER = /^(\+44|0044)?0?7[0-9]{9}$/; // 10 or 11 digits, must start with 0
exports.CONSIGNMENT_NUMBER_WITH_SEPARATED_LINE_NUMBER_00_ALLOWED =
  /^\d{10}\/\d$/; // 11 digits, includes slash
exports.DIGIT_12 = /^\d{12}$/; // 12 digits
exports.DIGIT_14 = /^\d{14}$/; // 14 digits
exports.CHARACTERS_14_OR_15 = /^.{14,15}$/; // 14 or 15 digits
exports.DIGIT_14_15_20_OR_28 = /^(.{14,15}$|.{20}|.{28})$/;
exports.CHARACTERS_20 = /^\.{20}$/; // 20 chars
exports.CHARACTERS_28 = /^\.{28}$/; // 28 chars
exports.DROP_OFF_CODE = /^\d{9}$/; // 9 digits
exports.SENDER_REF_CODE = /^[a-zA-Z]+[\w\d]+\*[\w\d]+$/; // 9 digits
exports.NUMERICAL_ONLY = /^[0-9]+$/; // numerical chars only
exports.EMAIL = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9-]+\.[A-Za-z0-9-.]+$/; // email address
exports.BASKET_ID = /^\d+\*\d{5}$/;
exports.DATE = /^(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d$/;
exports.ESG_DATE = /^(\d{4})-(0[1-9]|10|11|12)-([0-2][1-9]|10|20|30|31)$/;
exports.COUNTRY_CODE = /^[A-Z][A-Z]$/;
exports.TIME_SLOT = /^([0-9]|0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/;
exports.DEPOT_CODE = /^[0-9]{4}$/;

exports.HTML = /<\/?[^>]+(>|$)/g;
exports.WINDOW_SIZE = /^([0-9]+)\*([0-9]+)$/;
exports.DISALLOW_BFPO_POSTCODES_REGEXP = /^(?!BF[12].*$).*/; // The British Forces Post Office
exports.DISALLOW_BFPO_UDPRN_REGEXP = /^(?!99\d{6})/; // The British Forces Post Office
exports.CONTACT_NUMBER = /^(\+)?(\d|\s)*$/;

exports.GB_POSTCODE_PATTERN =
  /^(GIR[ ]?0AA)|([a-zA-Z]{1,2}(([0-9]{1,2})|([0-9][a-zA-Z]))[ ]?[0-9][a-zA-Z]{2})$/;
exports.IE_POSTCODE_PATTERN = /^[a-zA-Z0-9 ]*$/;
exports.PHONE_PATTERN = /^([+]\d{1,14}|\d{0,15})$/;
exports.EMAIL_PATTERN =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
exports.COUNTRY_CODE = /^[A-Z][A-Z]$/;
exports.EXPORTER_EORI_NUMBER = /^(GBUNREG)|((GB)\d{1,15})$/i;
exports.PAYMENT_AMOUNT = /^[0-9]+\.\d{2}$/;
exports.PARCEL_CODE = /^\d+\*\d{5}$/;

exports.WINDOW_SIZE = /^([0-9]+)\*([0-9]+)$/;
